import {Injectable} from '@angular/core';

@Injectable()
export class SearchAndPaginationService {

  private searchKeyWord: string;
  private offset: number = 0;
  private itemsPerPage: number = 10;

  public setSearchKeyWord(searchTerm: string) {
    this.searchKeyWord = searchTerm;
    this.offset = 0;
  }

  public searchKeyWordNotEquals(searchTerm: string) {
    return this.searchKeyWord !== searchTerm;
  }

  public getSearchKeyWord() {
    return this.searchKeyWord;
  }

  public setOffset(pageOffset: number) {
    this.offset = pageOffset;
  }

  public getOffset() {
    return this.offset;
  }

  public setItemsPerPage(pageSize: number) {
    this.itemsPerPage = pageSize;
  }

  public getItemsPerPage() {

    return this.itemsPerPage;
  }

  public resetValues() {
    this.searchKeyWord = '';
    this.itemsPerPage = 10;
    this.offset = 0;
  }
}
